import { createJsonApiHooks } from "./useJSON";

export const {
  useAll: useImgDescs,
  useOne: useImgDesc,
  useAdd: useAddImgDesc,
  useUpdate: useUpdateImgDesc,
  useDelete: useDeleteImgDesc
} = createJsonApiHooks("img_desc");